<template>
    <tr>
        <td>{{row.event}}</td>
        <td>{{row.depth}}</td>
        <td class="moreInfo" @click="openMoreInformation">
            Issuer params
            <div><img :class="{ rotate: openMoreInfo }" src="../../assets/images/down-arrow.svg" alt="open"></div>
        </td>
        <td>{{row.type}}</td>
        <td>{{row.value}}</td>
        <td>{{correctDate(row.datetime)}}</td>
        <td>
            {{row.limit_level}}
            <div class="deleteCheckBox" @click="selectItemToDelete">
                <div :class="{checked: deleteChecked}" v-if="checkFraudDelete">
                    <img v-if="deleteChecked" src="../../assets/images/checkBox.svg" alt="check">
                </div>
            </div>
        </td>
        <div :class="{ information_open: openMoreInfo}" class="information">
            <div class="information__wrapper">
                <div class="information__param" v-if="row.issuer_params.user_id">
                    UserId:
                    <span v-for="userId in row.issuer_params.user_id">
                        {{userId}}
                    </span>
                </div>
                <div class="information__param" v-if="row.issuer_params.username">
                    Username:
                    <span v-for="userName in row.issuer_params.username">
                        {{userName}}
                    </span>
                </div>
                <div class="information__param" v-if="row.issuer_params.ip">
                    Ip:
                    <span v-for="ip in row.issuer_params.ip">
                        {{ip}}
                    </span>
                </div>
                <div class="information__param" v-if="row.issuer_params.wallet">
                    Wallet:
                    <span v-for="wallet in row.issuer_params.wallet">
                        {{wallet}}
                    </span>
                </div>
                <div class="information__param" v-if="row.issuer_params.roblox_username">
                    Roblox Username:
                    <span v-for="robloxUserName in row.issuer_params.roblox_username">
                        {{robloxUserName}}
                    </span>
                </div>
                <div class="information__param" v-if="row.issuer_params.email">
                    Email:
                    <span v-for="email in row.issuer_params.email">
                        {{email}}
                    </span>
                </div>
                <div class="information__param" v-if="row.issuer_params.payment_system_invoice">
                    Payment system invoice:
                    <span v-for="payment in row.issuer_params.payment_system_invoice">
                        {{payment}}
                    </span>
                </div>
                <div class="information__param" v-if="row.issuer_params.withdrawl_id">
                    Withdrawl id:
                    <span v-for="withdraw in row.issuer_params.withdrawl_id">
                        {{withdraw}}
                    </span>
                </div>
                <div class="information__param" v-if="row.issuer_params.topup_id">
                    Topup id:
                    <span v-for="topup in row.issuer_params.topup_id">
                        {{topup}}
                    </span>
                </div>
            </div>
        </div>
    </tr>
</template>

<script>

export default {
    name: "TabelRowFraud",
    props: {
        row: {
            type: Object,
            require: true,
        }
    },
    data() {
        return {
            openMoreInfo: false,
            deleteChecked: false
        }
    },
    computed: {
        isPermissions () {
            return this.$store.state.permissions
        },
        checkFraudDelete () {
            if (this.row.limit_level === 'base' && this.isPermissions.fraud_delete_base) {
                return true
            }
            if (this.row.limit_level === 'full' && this.isPermissions.fraud_delete_full) {
                return true
            }
        }
    },
    methods: {
        openMoreInformation() {
            this.openMoreInfo = !this.openMoreInfo
        },
        correctDate (data) {
            return data.replace("T", " ").split('.')[0]
        },
        selectItemToDelete () {
            if (!this.deleteChecked) {
                this.$store.commit("addDeleteFraudItem", this.row._id)
            } else {
                this.$store.commit("removeDeleteFraudItem", this.row._id)
            }
            this.deleteChecked = !this.deleteChecked
        }
    }
}
</script>
